import { useMutation } from "@apollo/client";
import { useCallback, useState } from "react";

import { GqlPlannerV2TravelGroupRemoveVisitInput } from "~/__generated__/graphql/types";

import { PlannerV2TravelGroupRemoveVisitDocument } from "../mutations.generated";
import { PlannerV2TravelGroupGetTimelineDocument } from "../queries.generated";

export default function usePlannerV2TravelGroupRemoveVisit(onSuccess: (plannerTravelGroupId: string) => void) {
    const [loadingToRemoveVisitId, setLoadingToRemoveVisitId] = useState<string | null>(null);
    const [mutate, { data, loading, error }] = useMutation(PlannerV2TravelGroupRemoveVisitDocument, {
        refetchQueries: [PlannerV2TravelGroupGetTimelineDocument],
        awaitRefetchQueries: true,
    });

    const removeVisit = useCallback(
        async (input: GqlPlannerV2TravelGroupRemoveVisitInput) => {
            setLoadingToRemoveVisitId(input.plannerVisitId);
            try {
                const response = await mutate({
                    variables: { input },
                });
                const plannerTravelGroupId = response.data?.plannerV2TravelGroupRemoveVisit?.id;
                if (plannerTravelGroupId) onSuccess(plannerTravelGroupId);
            } finally {
                setLoadingToRemoveVisitId(null);
            }
        },
        [mutate, onSuccess],
    );

    return {
        removeVisit,
        loading,
        loadingToRemoveVisitId,
        error,
        data,
    };
}
